export class GlobalConstants{
    public static readonly getPreferenceEndpoint='optOutService/v1/getPreference';
    public static readonly updatePreferenceEndpoint='optOutService/v1/updatePreference';
    public static readonly getPreferenceApifEndpoint='sample/v1/getPreference';
    public static readonly updatePreferenceApifEndpoint='sample/v1/updatePreference';
    public static readonly getTokenEndpoint='optOutService/v1/getToken';
    public static readonly gdlOptOutPageId='US/en/fedex/fdmoptout/delivery-manager/privacy/opt-out';
    public static readonly gdlOptConfirmPageId='US/en/fedex/fdmoptout/delivery-manager/privacy/opt-out-confirm';
}